(function () {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  function hasSuccessfulWaitlistPost() {
    return new URLSearchParams(window.location.search).get('customer_posted') === 'true';
  }

  if (hasSuccessfulWaitlistPost()) {
    window.scrollTo(0, 0);

    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  function toNumber(value) {
    var parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function getInitialDuration(countdown) {
    if (countdown.dataset.launchDate) {
      var launchDate = new Date(countdown.dataset.launchDate);
      if (!Number.isNaN(launchDate.getTime())) {
        return Math.max(0, launchDate.getTime() - Date.now());
      }
    }

    var days = toNumber(countdown.dataset.days);
    var hours = toNumber(countdown.dataset.hours);
    var minutes = toNumber(countdown.dataset.minutes);
    var seconds = toNumber(countdown.dataset.seconds);

    return (((days * 24 + hours) * 60 + minutes) * 60 + seconds) * 1000;
  }

  function setText(countdown, part, value) {
    var node = countdown.querySelector('[data-countdown-part="' + part + '"]');
    if (!node) return;

    var nextValue = pad(value);
    if (node.textContent === nextValue) return;

    node.textContent = nextValue;
  }

  function render(countdown, remainingMs) {
    var totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    setText(countdown, 'days', days);
    setText(countdown, 'hours', hours);
    setText(countdown, 'minutes', minutes);
    setText(countdown, 'seconds', seconds);
  }

  function initCountdown(countdown) {
    if (countdown.dataset.countdownReady === 'true') return;

    countdown.dataset.countdownReady = 'true';
    var deadline = countdown.dataset.launchDate ? new Date(countdown.dataset.launchDate).getTime() : Date.now() + getInitialDuration(countdown);
    var duration = Math.max(0, deadline - Date.now());

    render(countdown, duration);

    window.setInterval(function () {
      render(countdown, deadline - Date.now());
    }, 1000);
  }

  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(initCountdown);
  }

  function waitlistMessage(form, selector, fallback) {
    var source = form.querySelector(selector);
    return source && source.textContent.trim() ? source.textContent.trim() : fallback;
  }

  function showWaitlistMessage(form, text) {
    var message = document.createElement('p');
    message.className = 'ggim-waitlist-form__message';
    message.setAttribute('role', 'status');
    message.textContent = text;
    form.replaceChildren(message);
  }

  function initWaitlistSuccess() {
    if (!hasSuccessfulWaitlistPost()) return;

    document.querySelectorAll('.ggim-waitlist-form').forEach(function (form) {
      showWaitlistMessage(
        form,
        waitlistMessage(form, '[data-waitlist-success-message]', "You're on the list. We'll be in touch soon.")
      );
    });

    window.requestAnimationFrame(function () {
      window.scrollTo(0, 0);
    });
  }

  function initWaitlistForms() {
    document.querySelectorAll('.ggim-waitlist-form').forEach(function (form) {
      if (form.action) {
        form.action = form.action.split('#')[0];
      }

      form.addEventListener('submit', function () {
        if (form.action) {
          form.action = form.action.split('#')[0];
        }
      });
    });
  }

  function initLoader() {
    var loader = document.querySelector('.ggim-loader');
    var loaderNumber = document.querySelector('[data-loader-number]');
    window.scrollTo(0, 0);

    if (!loader || !loaderNumber) {
      document.body.classList.add('ggim-site-ready');
      document.body.classList.remove('ggim-is-loading');
      window.scrollTo(0, 0);
      return;
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var progress = 0;
    var duration = prefersReducedMotion ? 250 : 1800;
    var milestones = [0, 14, 28, 42, 57, 71, 85, 100];
    var start = window.performance.now();
    var digitMarkup = Array.from({ length: 10 }, function (_, index) {
      return '<span>' + index + '</span>';
    }).join('');
    var loaderDigits = [];
    var loaderTickTimer;

    function ensureLoaderDigits(length) {
      if (loaderDigits.length === length) return;

      loaderNumber.innerHTML = Array.from({ length: length }, function () {
        return '<span class="ggim-loader__digit"><span class="ggim-loader__digit-stack">' + digitMarkup + '</span></span>';
      }).join('');

      loaderDigits = Array.from(loaderNumber.querySelectorAll('.ggim-loader__digit-stack'));
    }

    ensureLoaderDigits(3);

    function renderLoaderNumber(value) {
      var digits = String(value).padStart(3, '0').split('');
      ensureLoaderDigits(3);
      loaderNumber.setAttribute('aria-label', value + '%');
      loaderNumber.classList.toggle('is-hundreds', value >= 100);
      loaderNumber.classList.add('is-ticking');
      window.clearTimeout(loaderTickTimer);
      loaderTickTimer = window.setTimeout(function () {
        loaderNumber.classList.remove('is-ticking');
      }, 500);

      digits.forEach(function (digit, index) {
        var stack = loaderDigits[index];
        if (!stack) return;

        stack.style.setProperty('--loader-digit', digit);
      });
    }

    renderLoaderNumber(0);

    function finish() {
      renderLoaderNumber(100);
      loader.classList.add('is-complete');

      window.setTimeout(function () {
        window.scrollTo(0, 0);
        document.body.classList.add('ggim-site-ready');
        document.body.classList.remove('ggim-is-loading');
        window.requestAnimationFrame(function () {
          window.scrollTo(0, 0);
        });
      }, prefersReducedMotion ? 80 : 520);
    }

    function tick(now) {
      var elapsed = now - start;
      var rawProgress = Math.min(100, Math.floor((elapsed / duration) * 100));
      var nextProgress = milestones.reduce(function (current, milestone) {
        return rawProgress >= milestone ? milestone : current;
      }, 0);

      if (nextProgress !== progress) {
        progress = nextProgress;
        renderLoaderNumber(progress);
      }

      if (rawProgress >= 100) {
        finish();
        return;
      }

      window.requestAnimationFrame(tick);
    }

    window.requestAnimationFrame(tick);
  }

  function initRevealMotion() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealTargets = document.querySelectorAll(
      '.ggim-navbar, .ggim-waitlist-page__heading, .ggim-waitlist-form--hero, .ggim-social-proof'
    );

    revealTargets.forEach(function (target, index) {
      target.classList.add('ggim-reveal');
      target.style.setProperty('--ggim-reveal-delay', Math.min(index % 6, 5) * 70 + 'ms');
    });

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach(function (target) {
        target.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    revealTargets.forEach(function (target) {
      observer.observe(target);
    });
  }

  function initPremiumInteractions() {
    initWaitlistSuccess();
    initWaitlistForms();
    initCountdowns();
    initRevealMotion();
    initLoader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPremiumInteractions);
  } else {
    initPremiumInteractions();
  }
})();
